var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer 2",
    d: "M15 0.54834C6.71602 0.54834 0 7.26436 0 15.5483C0 23.8323 6.71602 30.5483 15 30.5483C23.284 30.5483 30 23.8323 30 15.5483C30 7.26436 23.284 0.54834 15 0.54834ZM19.9266 22.7729C19.9266 23.0325 19.8235 23.2814 19.64 23.4649C19.4565 23.6484 19.2076 23.7515 18.948 23.7515H11.052C10.7924 23.7515 10.5435 23.6484 10.36 23.4649C10.1765 23.2814 10.0734 23.0325 10.0734 22.7729V13.1917H19.9266V22.7729ZM20.9766 11.0677C20.9766 11.3842 20.8508 11.6878 20.627 11.9116C20.4031 12.1355 20.0996 12.2612 19.783 12.2612H10.2182C10.0613 12.2614 9.90599 12.2306 9.76105 12.1707C9.61611 12.1108 9.48439 12.0229 9.37344 11.9121C9.26248 11.8012 9.17446 11.6696 9.1144 11.5247C9.05435 11.3798 9.02344 11.2245 9.02344 11.0677V9.8501C9.02344 9.53355 9.14919 9.22996 9.37302 9.00613C9.59686 8.78229 9.90044 8.65654 10.217 8.65654H11.3086C11.3141 8.30673 11.457 7.97313 11.7064 7.72778C11.9558 7.48243 12.2917 7.34502 12.6416 7.34521H17.3584C17.7083 7.34502 18.0442 7.48243 18.2936 7.72778C18.543 7.97313 18.6859 8.30673 18.6914 8.65654H19.783C20.0996 8.65654 20.4031 8.78229 20.627 9.00613C20.8508 9.22996 20.9766 9.53355 20.9766 9.8501V11.0677Z",
    fill: "#222222"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCircle);
export default __webpack_public_path__ + "static/media/delete-circle.5e0fe941a9c58e379a00e431f7a090b7.svg";
export { ForwardRef as ReactComponent };